import { SpinLoading } from 'respinner'

interface LoadingSpinnerProps {
  size?: number
  color?: string
}

export function LoadingSpinner({
  size = 35,
  color = '#254769',
}: LoadingSpinnerProps) {
  return (
    <SpinLoading
      color={color}
      size={size}
      borderRadius={3}
      barWidth={3}
      count={10}
    />
  )
}
